class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.headerWrapper = this.closest('#shopify-section-header');
    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse');
      this.shadow = this.header.querySelector('.header-shadow');

      // extra events
      this.shadow?.addEventListener('click', this.closeAll.bind(this));

      /*
        Generating breadcrumbs:
        If a collection has multiple parents in the main menu, it doesn't show the right breadcrumb path.
        Therefore we get the right path with js and save it in sessionStorage to use on the PDP
      */

      // get all level 3 links in the main menu
      const allGrandChildLinks = document.querySelectorAll('[data-breadcrumbs]') || false;

      // get element by click
      allGrandChildLinks.forEach(element => {
        element.addEventListener('click', event => {
          // prevent opening the link
          event.preventDefault();
          const url = event.currentTarget.href;
          if (url == undefined) {
            return false;
          }

          // add breadcrumbs to sessionStorage
          const dataBreadcrumbs = event.currentTarget.dataset.breadcrumbs;

          if (dataBreadcrumbs == undefined) {
            return false;
          }
          sessionStorage.setItem('breadcrumbs', dataBreadcrumbs);

          // continue opening the link
          window.location = url;
        })
      });

    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  open(group) {

    super.open(group);
    if (this.headerWrapper) {
      this.headerWrapper.classList.add('shopify-section-header--open');
    }
    this.toggleHeaderClass(true);

    // when level 1 is open, open first submenu
    if (group.matches('.header__menu-item--level-1.header__menu-item--is-open')) {
      group.querySelector('.header__menu-link--level-2:first-child')?.classList.add('header__menu-item--is-open');
    }

    let scrollPostion = window.scrollY || document.documentElement.scrollTop;
    sessionStorage.setItem('savedScrollPostion', scrollPostion);
  }

  close(group) {
    super.close(group);
    if (this.headerWrapper) {
      this.headerWrapper.classList.remove('shopify-section-header--open');
    }
    this.toggleHeaderClass(false);
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
    document.querySelector('sticky-header').classList.remove('header--search-is-open');
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false;
    }

    if (open) {
      // set header open
      this.header.classList.add('header--is-open');
      this.inverse && this.header.classList.add('header--inverse-solid');
    } else {
      // set header closed if all menu items are closed
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        this.header.classList.remove('header--is-open');
        this.inverse && this.header.classList.remove('header--inverse-solid');
      }
    }
  }
}


class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.headerWrapper = this.closest('#shopify-section-header');
    if (this.header) {
      this.inverse = !!this.header.classList.contains('header--inverse');
      this.shadow = this.header.querySelector('.header-shadow');

      // iPhone fix
      if (navigator.platform === 'iPhone') {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }

      // extra events
      document.addEventListener('keyup', this.onKeyUp.bind(this));
      this.shadow?.addEventListener('click', this.remove.bind(this));
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if (!this.header?.classList.contains('header--is-open')) {
      return;
    }
    if(event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      this.header.classList.add('header--is-open');
      this.inverse && this.header.classList.add('header--inverse-solid');
      document.querySelector('body').classList.add('mobile-menu--is-open');
    }
    if (this.headerWrapper) {
      this.headerWrapper.classList.add('shopify-section-header--open');
    }
    trapFocus(this.header);
  }

  remove() {
    super.remove();

    const sectionHeader = this.closest('#shopify-section-header');
    const theHeader = sectionHeader.querySelector('[data-header]');

    if (theHeader) {
      theHeader.classList.remove('header--is-open');
      this.inverse && theHeader.classList.remove('header--inverse-solid');
      document.querySelector('body').classList.remove('mobile-menu--is-open');
    }
    if (this.headerWrapper) {
      this.headerWrapper.classList.remove('shopify-section-header--open');
    }
    this.closeAllSibblings();
    removeTrapFocus();
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector('collapsible-element');
    collapsibles.closeAll();
  }
}


class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();

    // elements
    this.header = this.closest('[data-header]');

    // options
    const { toggleClass, target } = this.options;

    // key up escape
    document.addEventListener('keyup', this.onKeyUp.bind(this));

    // custom close button
    this.closeButtons = this.target?.querySelectorAll('[data-search-close-button]');
    this.closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', (e) => {
        this.preventDefault(e);
        this.stopPropagation(e);
        this.header.querySelector('.predictive-search').style.display = 'none';
        this.remove();
      });
    });

    // Remove classes incase the header navigation drawer is open.
    this.addEventListener('click', () => {
      this.header.querySelector('input[type="search"]').focus();
    });

    // click outside search
    document.addEventListener("click", (e) => {
      // if search is open
      if (this.target?.classList.contains(toggleClass)) {
        const isOutside = !e.target.closest(target);
        if (isOutside) {
          this.remove();
        }
      }
    });
  }

  onKeyUp(event) {
    if (!this.header?.classList.contains('header--search-is-open')) {
      return;
    }
    if(event?.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      this.header.classList.add('header--search-is-open');
    }
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    if (this.header) {
      this.header.classList.remove('header--search-is-open');
      this.header.querySelector('input[type="search"]').value = '';
    }
    removeTrapFocus();
  }

}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // select element
    this.header = document.querySelector('[data-header]');
    this.headerWrapper = document.querySelector('#shopify-section-header');
    this.announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.headerElement = this;
    this.headerInverse = !!this.headerElement.classList.contains('header--inverse');
    this.headerNav = this.querySelector('collapsible-header');
    this.mobileNav = this.querySelector('toggle-mobile-navigation');
    this.search = this.querySelector('[data-header-search]');
    this.searchToggle = this.querySelector('toggle-search');

    if (this.headerWrapper) {
      // scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      if (this.announcementBar) {

        const announcementBarHeight = this.announcementBar.clientHeight;
        this.scrollOffset += announcementBarHeight;
        this.headerStart += announcementBarHeight;

        const menuDrawer = document.querySelector('.announcement-bar-visible .shopify-section-header--open:not(.shopify-section-header--sticky) .menu-drawer') || false;
        if (menuDrawer) {
          menuDrawer.style.top = `${announcementBarHeight}px`;
          menuDrawer.style.height = `calc(100vh - ${announcementBarHeight}px)`;
          menuDrawer.style.maxHeight = `calc(100svh - ${announcementBarHeight}px)`;
        }

        const menuDrawerNav = document.querySelector('.announcement-bar-visible .shopify-section-header--open:not(.shopify-section-header--sticky) .menu-drawer__navigation') || false;
        if (menuDrawerNav) {
          menuDrawerNav.style.height = `calc(100vh - ${announcementBarHeight}px)`;
          menuDrawerNav.style.maxHeight = `calc(100svh - ${announcementBarHeight}px)`;
        }

        const menuDrawerSub = document.querySelector('.announcement-bar-visible .shopify-section-header--open:not(.shopify-section-header--sticky) .menu-drawer__submenu--level-2') || false;
        if (menuDrawerSub) {
          menuDrawerSub.style.height = `calc(100vh - 84px - ${announcementBarHeight}px)`;
          menuDrawerSub.style.maxHeight = `calc(100svh - 84px - ${announcementBarHeight}px)`;
        }

      }

      if (this.headerElement) {
        this.scrollOffset += this.headerElement.offsetHeight;
      }

      // scroll event
      this.raf = null; // Safe request animation frame
      this.timer = null, // Safe scroll timer
      window.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        if (!this.raf) {
          // A request animation frame is used to animate on max 60fps.
          this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
        }
        this.timer = setTimeout(() => {
          // Stop animation, cancel request animation frame
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }, 50);
      }, false);

    }
  }

  scrollAnimation() {
    let savedScrollPostion = parseInt(sessionStorage.getItem('savedScrollPostion'));
    let top = savedScrollPostion - 64;
    let bottom = savedScrollPostion + 64;
    if (top > 0) {
      top = 0;
    }
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (top <= scrollTop || bottom >= scrollTop) {

      if((scrollTop + window.innerHeight) > document.body.clientHeight) {
        this.hide();
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.scrollOffset) {
        this.hide();
      } else if (scrollTop <= this.headerStart) {
        this.revealTop();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerStart) {
        this.reveal();
      }
    }

    this.currentScrollTop = scrollTop;

    // Recall request animation loop
    this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
  }

  hide() {
    this.headerWrapper.classList.add('shopify-section-header--hidden', 'shopify-section-header--sticky');
    this.closeHeaderNav();
    this.closeMobileNav();
    this.closeSearch();
  }

  reveal() {
    this.headerWrapper.classList.add('shopify-section-header--sticky', 'shopify-section-header--animate');
    this.headerWrapper.classList.remove('shopify-section-header--hidden');
    if (this.headerInverse) {
      this.headerElement.classList.add('header--inverse-solid');
    }
  }

  revealTop() {
    if (this.headerInverse && !this.classList.contains('header--is-open')) {
      this.headerElement.classList.remove('header--inverse-solid');
    }
    this.headerWrapper.classList.remove('shopify-section-header--hidden', 'shopify-section-header--sticky', 'shopify-section-header--animate');
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if(!this.mobileNav) {
      return false;
    }
    this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains('header__search--is-active')) {
      this.searchToggle.remove();
    }
  }

}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
